// extracted by mini-css-extract-plugin
module.exports = {"modal__close":"_1s95gEIEwV9PAaj2X6QV5d"};